/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_EmptyInputs */

const en_clients_empty = /** @type {(inputs: Clients_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clients yet. Add the first one.`)
};

const pt_br2_clients_empty = /** @type {(inputs: Clients_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cliente ainda. Adicione o primeiro.`)
};

/**
* | output |
* | --- |
* | "No clients yet. Add the first one." |
*
* @param {Clients_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_empty = /** @type {((inputs?: Clients_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_empty(inputs)
	return pt_br2_clients_empty(inputs)
});